/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty */

import React, { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import {
  Box,
  Button,
  Chip,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import {
  capitalize,
  extractOnlyNumbers,
  formatToCustomDate,
  getDateProperFormatForInput,
  parseOnlyNumericValue,
  removeAllSpaces,
  removeExtraSpace,
  removeSpecialCharAndNumFn1,
  safeToString,
  sliceText,
} from "../../../utils/common";

import { TbMail, TbMapPin, TbPencil, TbPhone, TbWorldPin } from "react-icons/tb";
import { useAuthContext } from "../../../context/authContext";
import { useToast } from "../../../context/toast-context";
import useSnackbar from "../../../hook/use-snakbar";
import { Icon } from "../../../ppui/icon";
import { Snackbar } from "../../../ppui/snackbar";
import { logger, removeMultipleSpace, safeString } from "../../../utils/logger";
import useCommonApiCall from "../../../utils/useCommonApiCall";
import useCommonfn from "../../../utils/useCommonfn";
import { Card, CardHeading, CardViewBox, CardViewBoxBorder } from "../../style";
import { BRANCH_INITIAL_STATE } from "./branch-constant";
import { branchSchema } from "./branch-validation";

function OrganizationalBranch() {
  const { navigateToDashBoard } = useCommonfn();
  const { orgDetails } = useAuthContext();

  const { getStateName } = useCommonApiCall();
  const {
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
  } = useSnackbar();
  const { fetchData } = useAPIHandler();
  const [branchData, setBranchData] = useState([]);
  const [allState, setAllState] = useState([]);
  const [errors, setErrors] = useState({});
  const [open, setOpen] = React.useState(false);
  const [branchUiLoading, setbranchUiLoading] = useState(false);
  // const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { showToastMessage } = useToast();

  const handleClickOpen = () => {
    setErrors({});
    setBranchInfo(structuredClone(BRANCH_INITIAL_STATE));
    setOpen(true);
  };
  const handleClickOpenEditModal = (data) => {
    setErrors({});
    setOpen(true);
    setBranchInfo({
      ...data,
      date_of_est: getDateProperFormatForInput(data?.date_of_est),
    });
    // setOpen(false)
  };

  const [branchInfo, setBranchInfo] = useState(BRANCH_INITIAL_STATE);
  const fetchBranchData = async () => {
    setbranchUiLoading(true);
    try {
      const result = await fetchData({
        url: "organization/org-branch",
        method: "GET",
      });
      setbranchUiLoading(false);

      setBranchData(result?.data);
    } catch {
      setbranchUiLoading(false);
    }
  };
  const fetchAllState = async () => {
    try {
      const response = await fetchData({
        url: "/common/state",
        method: "GET",
      });
      if (response?.status === "success" && Array.isArray(response?.data)) {
        const mappedData = response?.data?.map((item) => ({
          id: item?.state_id,
          name: item?.state_name,
        }));
        setAllState(mappedData);
      }
    } catch (error) { }
  };
  function handleBlurFn(e, name) {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    const fieldSchema = branchSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      context: { date_of_org: orgDetails?.date_of_org },
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  }
  const handleChange = (e, name) => {
    // const { name, value } = e.target;
    let value = e;
    if (e && e.target) {
      value = e.target.value;
      name = e.target.name;
    }
    if (name === "pincode") {
      value = sliceText(parseOnlyNumericValue(removeAllSpaces(value)), 6);
    }
    if (name === "email") {
      value = removeExtraSpace(value);
    }
    if (name === "branch_name") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if (name === "address") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if (name === "contact_person") {
      value = sliceText(
        removeMultipleSpace(safeToString(removeSpecialCharAndNumFn1(value))),
        150
      );
    }
    if (name === "city") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if (name === "landmark") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if (name === "locality") {
      value = sliceText(removeMultipleSpace(safeToString(value)), 150);
    }
    if (name === "contact_number") {
      value = sliceText(removeAllSpaces(extractOnlyNumbers(value)), 11);
    }
    setBranchInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));

    const fieldSchema = branchSchema.extract(name);
    const { error } = fieldSchema.validate(value);
    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error ? error.details[0].message : undefined,
      }));
    }
  };
  const handleSubmit = async () => {
    const {
      branch_name,
      contact_number,
      contact_person,
      email,
      date_of_est,
      address,
      locality,
      city,
      state,
      country,
      pincode,
      landmark,
      status,
    } = branchInfo || {};
    const { error } = branchSchema.validate(
      {
        branch_name,
        contact_number,
        contact_person,
        email,
        date_of_est,
        address,
        locality,
        city,
        state,
        country,
        pincode,
        landmark,
        status,
      },
      {
        abortEarly: false,
        context: { date_of_org: orgDetails?.date_of_org },
      }
    );

    if (error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
      // setCreateUpdateLoading(false);
    } else {
      setErrors({});
      try {
        const url = branchInfo?.branch_id
          ? `organization/modify-org-branch/${branchInfo?.branch_id}`
          : `organization/create-org-branch`;
        const payload = {
          url: url,
          method: "POST",
          data: {
            branch_name,
            contact_number,
            contact_person,
            email,
            date_of_est: date_of_est ? date_of_est : null,
            address,
            locality,
            city,
            state,
            country: safeString(country),
            pincode: safeString(pincode),
            ...(branchInfo?.branch_id && { status }),
            landmark,
          },
        };

        const response = await fetchData(payload);

        if (response.status === "success") {
          // await fetchOrgBranchData();
          const isUpdate = !!branchInfo?.branch_id;
          const successMessage = isUpdate
            ? "Branch updated successfully!"
            : "Branch created successfully!";
          setBranchInfo(BRANCH_INITIAL_STATE);
          fetchBranchData();
          showToastMessage({ message: successMessage });
        }
        handleClose();
      } catch (error) {
        handleClose();
        logger.log(error, "branch-error")
        if (error?.type === "JoiValidationError") {
          const errorsAll = {};
          error?.errors?.reduce((acc, curr) => {
            const { field, message } = curr;

            errorsAll[field] = message;

            return acc;
          });

          showToastMessage({
            message:
              Object.keys(errorsAll).length > 0
                ? "Validation Error!"
                : "Something went wrong!",
            color: "danger",
          });

          setErrors(errorsAll);
        }
        if (error?.type === "GeneralError") {
          logger.log("GeneralError detected:", error?.message);
          showToastMessage({
            message: error?.message || "An error occurred. Please try again.",
            color: "danger",
          });
        }
      }
    }
  };

  useEffect(() => {
    fetchBranchData();
    fetchAllState();
  }, []);

  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  if (branchUiLoading) {
    return <p>Loading Branch...</p>;
  }

  return (
    <>
      <Card>
        <CardHeading Divider>
          Branch Details
          {branchData.length > 0 && (
            <Button
              color="primary"
              variant="contained"
              size="sm"
              onClick={handleClickOpen}
              icon={<TbWorldPin />}
            >
              Add Branch
            </Button>
          )}
        </CardHeading>

        {!branchData.length ? (
          <>
            <Row rowGap>
              <Col sm={12} md={6} lg={4} xl={3}>
                <InputField
                  fullWidth
                  label="Branch Name"
                  name="branch_name"
                  placeholder="Type Here"
                  type="text"
                  value={branchInfo.branch_name}
                  valueSinc={!!branchInfo.branch_name}
                  onChange={(e) => handleChange(e.target.value, "branch_name")}
                  error={errors.branch_name}
                  helperText={errors.branch_name}
                  required={true}
                  onBlur={(e) => handleBlurFn(e, "branch_name")}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Branch Contact"
                  name="contact_number"
                  placeholder="Type Here"
                  type="tel"
                  value={branchInfo.contact_number}
                  valueSinc={!!branchInfo.contact_number}
                  onChange={(e) => handleChange(e.target.value, "contact_number")}
                  error={errors.contact_number}
                  helperText={errors.contact_number}
                  required={true}
                  onBlur={(e) => handleBlurFn(e, "contact_number")}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Branch Email"
                  name="email"
                  placeholder="Type Here"
                  type="tel"
                  value={branchInfo.email}
                  valueSinc={!!branchInfo.email}
                  onChange={(e) => handleChange(e.target.value, "email")}
                  error={errors.email}
                  helperText={errors.email}
                  required={true}
                  onBlur={(e) => handleBlurFn(e, "email")}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Contact Person"
                  name="contact_person"
                  placeholder="Type Here"
                  type="tel"
                  value={branchInfo.contact_person}
                  valueSinc={!!branchInfo.contact_person}
                  onChange={(e) => handleChange(e.target.value, "contact_person")}
                  error={errors.contact_person}
                  helperText={errors.contact_person}
                  onBlur={(e) => handleBlurFn(e, "contact_person")}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Date Of Established"
                  name="date_of_est"
                  placeholder="Type Here"
                  type="date"
                  value={branchInfo.date_of_est}
                  // defaultValue={branchInfo.date_of_est}
                  valueSinc
                  onChange={(e) => handleChange(e.target.value, "date_of_est")}
                  error={errors.date_of_est}
                  helperText={errors.date_of_est}
                  max={getTodayDate()}
                  onKeyDown={(e) => e.preventDefault()}
                  onBlur={(e) => handleBlurFn(e, "date_of_est")}
                />
              </Col>
            </Row>
            <Divider gap={20} />
            <Row rowGap>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Address"
                  name="address"
                  placeholder="Type Here"
                  type="text"
                  value={branchInfo.address}
                  valueSinc={!!branchInfo.address}
                  onChange={(e) => handleChange(e.target.value, "address")}
                  error={errors.address}
                  helperText={errors.address}
                  onBlur={(e) => handleBlurFn(e, "address")}
                />
              </Col>

              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Locality"
                  name="locality"
                  placeholder="Type Here"
                  type="text"
                  value={branchInfo.locality}
                  valueSinc={!!branchInfo.locality}
                  onChange={(e) => handleChange(e.target.value, "locality")}
                  error={errors.locality}
                  helperText={errors.locality}
                  onBlur={(e) => handleBlurFn(e, "locality")}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="City/District"
                  name="city"
                  placeholder="Type Here"
                  type="text"
                  value={branchInfo.city}
                  valueSinc={!!branchInfo.city}
                  onChange={(e) => handleChange(e.target.value, "city")}
                  error={errors.city}
                  helperText={errors.city}
                  onBlur={(e) => handleBlurFn(e, "city")}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <SelectField
                  fullWidth
                  label="State"
                  name="state"
                  options={allState}
                  placeholder="Type here..."
                  defaultValue={branchInfo.state}
                  valueSinc={!!branchInfo.state}
                  onChange={(val) => handleChange(val, "state")}
                  error={errors.state}
                  helperText={errors.state}
                  onBlur={(e) => handleBlurFn(e, "state")}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <SelectField
                  fullWidth
                  label="Country"
                  name="country"
                  options={[{ id: "india", name: "India" }]}
                  valueSinc
                  defaultValue={branchInfo?.country}
                  disabled
                  onBlur={(e) => handleBlurFn(e, "country")}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Pincode"
                  name="pincode"
                  type="text"
                  placeholder="Type Here"
                  // value={sliceText(parseOnlyNumericValue(removeAllSpaces(branchInfo.pincode)), 6)}
                  value={branchInfo.pincode}
                  valueSinc={!!branchInfo.pincode}
                  onChange={(e) => handleChange(e.target.value, "pincode")}
                  error={errors.pincode}
                  helperText={errors.pincode}
                  onBlur={(e) => handleBlurFn(e, "pincode")}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xxl={3}>
                <InputField
                  fullWidth
                  label="Landmark"
                  name="landmark"
                  placeholder="Type Here"
                  type="text"
                  value={branchInfo.landmark}
                  valueSinc={!!branchInfo.landmark}
                  onChange={(e) => handleChange(e.target.value, "landmark")}
                  error={errors.landmark}
                  helperText={errors.landmark}
                  onBlur={(e) => handleBlurFn(e, "landmark")}
                />
              </Col>
            </Row>
            <Gap height={20} />
            <Flex justifyContent="flex-end" gap={"10"}>
              <Button variant="outlined" onClick={navigateToDashBoard}>
                Cancel
              </Button>

              <Button
                onClick={() => handleSubmit()}
                color="primary"
                variant="contained"
              >
                Save
              </Button>
              <Snackbar
                message={snackbarMessage}
                color={snackColor}
                variant="contained"
                size="medium"
                position="top-right"
                onClose={closeSnackbar}
                onOpen={snackbarVisible}
                loading={false}
                duration={3000}
              />
            </Flex>
          </>
        ) : (
          <>
            <Row rowGap mb={20}>
              {branchData?.map((item) => {
                const fullAddress = [
                  item?.address,
                  item?.locality,
                  item?.city,
                  item?.state ? getStateName(item.state) : "",
                  item?.country ? capitalize(item.country) : "",
                  item?.landmark,
                  item?.pincode,
                ]
                  .filter(Boolean) // Remove falsy values
                  .join(", ");
                return (
                  <>
                    <Col sm={12} md={6} lg={6} xl={4} key={item?.id}>
                      <CardViewBox>
                        <Row alignItem="center" mb={15}>
                          <Col>
                            <Typography
                              variant="body1"
                              strong
                              mb={"0"}
                              color="primary"
                              textCase="capitalize"
                            >
                              {item?.branch_name}
                            </Typography>

                            <Typography variant="body2" mb={"0"}>
                              Est. Date:{" "}
                              {item?.date_of_est
                                ? formatToCustomDate(
                                  new Date(
                                    getDateProperFormatForInput(
                                      item?.date_of_est
                                    )
                                  )
                                )
                                : "N/A"}
                            </Typography>
                          </Col>

                          <Col sm={"auto"} ml={"auto"}>
                            <FabButton
                              icon={<TbPencil />}
                              shape="rounded"
                              size="sm"
                              variant="filled"
                              onClick={() => handleClickOpenEditModal(item)}
                            />
                          </Col>
                        </Row>
                        <CardViewBoxBorder />
                        <Flex
                          alignItem="center"
                          gap={"5"}
                          justifyContent="space-between"
                        >
                          <Typography variant="h6" mb={"5"} textCase="capitalize">
                            {item?.contact_person}
                          </Typography>
                          <Chip
                            color={item?.status ? "success" : "danger"}
                            label={item?.status ? "Open" : "Close"}
                            onClick={() => { }}
                            size="sm"
                            dot
                          />
                        </Flex>
                        <Flex alignItem="center" gap={"5"}>
                          <Icon>
                            <TbPhone />
                          </Icon>

                          <Typography variant="body2" mb={"0"}>
                            {item?.contact_number}
                          </Typography>
                        </Flex>
                        <Flex alignItem="center" gap={"5"}>
                          <Icon>
                            <TbMail />
                          </Icon>

                          <Typography variant="body2" mb={"0"}>
                            {item?.email}
                          </Typography>
                        </Flex>
                        <Flex alignItem="center" gap={"5"}>
                          <Icon>
                            <TbMapPin />
                          </Icon>
                          <Typography variant="body2" mb={"0"}>
                            {fullAddress ?? "N/A"}
                          </Typography>
                        </Flex>
                      </CardViewBox>
                    </Col>
                  </>
                );
              })}
            </Row>
          </>
        )}
      </Card>
      {/* Modal */}
      <Dialog
        title={`${!branchInfo?.branch_id ? "Create New" : "Update"} Branch`}
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={() => handleSubmit()}
        separator
        bodyScroll={true}
        setData={(value) => {
          setBranchInfo({
            ...value,
            date_of_est: getDateProperFormatForInput(value?.date_of_est),
          });
        }}
        buttonName={!branchInfo?.branch_id ? "Submit" : "Update"}
      >
        <Row rowGap>
          <Col sm={6}>
            <Box>
              <InputField
                fullWidth
                label="Branch Name"
                name="branch_name"
                placeholder="Type Here"
                type="text"
                value={branchInfo.branch_name}
                valueSinc={!!branchInfo.branch_name}
                onChange={(e) => handleChange(e.target.value, "branch_name")}
                error={errors.branch_name}
                helperText={errors.branch_name}
                required={true}
                onBlur={(e) => handleBlurFn(e, "branch_name")}
              />
            </Box>
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Branch Contact"
              name="contact_number"
              placeholder="Type Here"
              type="tel"
              value={branchInfo.contact_number}
              valueSinc={!!branchInfo.contact_number}
              onChange={(e) => handleChange(e.target.value, "contact_number")}
              error={errors.contact_number}
              helperText={errors.contact_number}
              required={true}
              onBlur={(e) => handleBlurFn(e, "contact_number")}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Branch Email"
              name="email"
              placeholder="Type Here"
              type="tel"
              value={branchInfo.email}
              valueSinc={!!branchInfo.email}
              onChange={(e) => handleChange(e.target.value, "email")}
              error={errors.email}
              helperText={errors.email}
              required={true}
              onBlur={(e) => handleBlurFn(e, "email")}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Contact Person"
              name="contact_person"
              placeholder="Type Here"
              type="tel"
              value={branchInfo.contact_person}
              valueSinc={!!branchInfo.contact_person}
              onChange={(e) => handleChange(e.target.value, "contact_person")}
              error={errors.contact_person}
              helperText={errors.contact_person}
              onBlur={(e) => handleBlurFn(e, "contact_person")}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Date Of Established"
              name="date_of_est"
              placeholder="Type Here"
              type="date"
              value={branchInfo.date_of_est}
              defaultValue={branchInfo.date_of_est}
              valueSinc
              onChange={(e) => handleChange(e.target.value, "date_of_est")}
              error={errors.date_of_est}
              helperText={errors.date_of_est}
              max={getTodayDate()}
              onKeyDown={(e) => e.preventDefault()}
              onBlur={(e) => handleBlurFn(e, "date_of_est")}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Address"
              name="address"
              placeholder="Type Here"
              type="text"
              value={branchInfo.address}
              valueSinc={!!branchInfo.address}
              onChange={(e) => handleChange(e.target.value, "address")}
              error={errors.address}
              helperText={errors.address}
              onBlur={(e) => handleBlurFn(e, "address")}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Locality"
              name="locality"
              placeholder="Type Here"
              type="text"
              value={branchInfo.locality}
              valueSinc={!!branchInfo.locality}
              onChange={(e) => handleChange(e.target.value, "locality")}
              error={errors.locality}
              helperText={errors.locality}
              onBlur={(e) => handleBlurFn(e, "locality")}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="City/District"
              name="city"
              placeholder="Type Here"
              type="text"
              value={branchInfo.city}
              valueSinc={!!branchInfo.city}
              onChange={(e) => handleChange(e.target.value, "city")}
              error={errors.city}
              helperText={errors.city}
              onBlur={(e) => handleBlurFn(e, "city")}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              fullWidth
              label="State"
              name="state"
              options={allState}
              placeholder="Type here..."
              defaultValue={branchInfo.state}
              valueSinc={!!branchInfo.state}
              onChange={(val) => handleChange(val, "state")}
              error={errors.state}
              helperText={errors.state}
              onBlur={(e) => handleBlurFn(e, "state")}
            />
          </Col>

          <Col sm={6}>
            {/*<SelectField*/}
            {/*  fullWidth*/}
            {/*  label="Country"*/}
            {/*  name="country"*/}
            {/*  options={[{ id: "india", name: "India" }]}*/}
            {/*  valueSinc={!!branchInfo?.country}*/}
            {/*  defaultValue={branchInfo?.country}*/}
            {/*  disabled*/}
            {/*  onBlur={(e) => handleBlurFn(e, "country")}*/}
            {/*/>*/}
            <InputField
              disabled
              fullWidth
              label="Country"
              name="country"
              type="text"
              placeholder="Type Here"
              value={"India"}
              valueSinc
            // onChange={(e) => handleChange(e.target.value, "pincode")}
            // error={errors.pincode}
            // helperText={errors.pincode}
            // onBlur={(e) => handleBlurFn(e, "pincode")}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Pincode"
              name="pincode"
              type="text"
              placeholder="Type Here"
              value={branchInfo.pincode}
              valueSinc={!!branchInfo.pincode}
              onChange={(e) => handleChange(e.target.value, "pincode")}
              error={errors.pincode}
              helperText={errors.pincode}
              onBlur={(e) => handleBlurFn(e, "pincode")}
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Landmark"
              name="landmark"
              placeholder="Type Here"
              type="text"
              value={branchInfo.landmark}
              valueSinc={!!branchInfo.landmark}
              onChange={(e) => handleChange(e.target.value, "landmark")}
              error={errors.landmark}
              helperText={errors.landmark}
              onBlur={(e) => handleBlurFn(e, "landmark")}
            />
          </Col>
          {branchInfo?.branch_id && (
            <Col sm={6}>
              <SelectField
                fullWidth
                label="Status"
                name="status"
                options={[
                  { id: true, name: "Open" },
                  { id: false, name: "Close" },
                ]}
                valueSinc={!!branchInfo.status}
                defaultValue={branchInfo.status}
                placeholder="Select Status"
                error={errors.status}
                helperText={errors.status}
                onChange={(val) => handleChange(val, "status")}
                onBlur={(e) => handleBlurFn(e, "status")}
              />
            </Col>
          )}
        </Row>
      </Dialog>
      {/* Modal */}
    </>
  );
}

export default OrganizationalBranch;
